import * as React from 'react';

import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Divider from '@mui/material/Divider';
import Button from '@mui/material/Button';
import List from '@mui/material/List';
import TickBoxDish from './TickBoxDish';

import * as ApiCall from '../ApiCall.jsx';
import { ReactReduxContext } from 'react-redux';


// component that shows the status of dishes, cooking or ready=cooked
// if ready, can be served by ticking check box, can be unserved also
export default function WaitOrderCard ({orderInfo, completeOrder}) {

  const orderID = orderInfo.id;
  const tableNumber = orderInfo.tableNumber;
  let dishes = orderInfo.dishes;
  let dishIDs = Object.keys(dishes);

  const [ready, setReady] = React.useState(getReady());

  const [cooking, setCooking] = React.useState(getCooking());

  function getReady() {
    let r = [];
    for (let dishID of dishIDs) {
      if (dishes[dishID].status > 1) {
        r.push([dishID, dishes[dishID]]);
      }
    }
    return r;
  }
  function getCooking() {
    let c = [];
    for (let dishID of dishIDs) {
      if (dishes[dishID].status <= 1) {
        c.push([dishID, dishes[dishID]]);
      }
    }
    return c;
  }

  const [complete, setComplete] = React.useState(false);

  function allServed() {

    if (cooking.length > 0) {return false}
    for (let i = 0; i < ready.length; i++) {
      if (ready[i][1].status < 3) {
        return false;
      }
    }

    return true;
  }

  React.useEffect(() => {
    if (allServed()) {
      setComplete(true);
    } else {
      setComplete(false);
    }
  }, [ready])

  React.useEffect(() => {
    setReady(getReady());
    setCooking(getCooking());
  }, [orderInfo])

  
  function serve(dishID) {
    //api call to set a dish to served in backend
    
    ApiCall.post("/wait_staff/serveDish", "orderId="+orderInfo.id+"&dishId="+dishID)
    .then(() => {
      //set the state for the given dish to served
      for (let i = 0; i < ready.length; i++) {
        if (ready[i][0] == dishID) {
          let copy = [...ready];
          copy[i][1].status = 3;
          setReady(copy);
        }
      }
    })
    .catch((msg) => { alert("Failed to serve dish: " + msg)});
  }

  function unserve(dishID) {
    //api call to set a dish unserved in backend, will work for all but the last served item
    //as serving that will close the order
    ApiCall.post("/wait_staff/unserveDish", "orderId="+orderInfo.id+"&dishId="+dishID)
    .then(() => {
      //set the state for the given dish to un-served
      for (let i = 0; i < ready.length; i++) {
        if (ready[i][0] == dishID) {
          
          let copy = [...ready];
          copy[i][1].status = 2;
          setReady(copy);
        }
      }
      //cant be complete if a dish is not served
      setComplete(false);
    })
    .catch((msg) => { alert("Failed to unserve dish: " + msg)});
  }


  function CompleteOrderButton() {
    
    if (complete) {
      return(
        <Button variant="contained" sx={{fontSize: "1.1rem", p: 2, height: 0.4, textTransform: 'none', backgroundColor: "black", ':hover': {
                  color: 'white',
                  bgcolor: 'grey'
                }}}
                onClick={completeOrder}>
          Complete Order
        </Button>
      )
    }

    else if (!complete) {
      return (
        <Button disabled variant="contained" sx={{fontSize: "1.1rem", p: 2, height: 0.4, textTransform: 'none', backgroundColor: "black", ':hover': {
                  color: 'white',
                  bgcolor: 'grey',
                }}}>
          Complete Order
        </Button> 
      )
    }
  }



  return ( 
    <Box sx={{ borderRadius: '25px', backgroundColor: '#eeeeee', display: 'flex', flexDirection: 'column', width: 1, p: 3}}>
      <Box sx={{display: 'flex', flexDirection: 'row', justifyContent: 'space-between', pb: 1}}>
        <Box sx={{display: 'flex', flexDirection: 'column', justifyContent: 'space-between'}}>
          <Typography variant="h5" sx={{fontWeight: "bold"}}>
            Table {tableNumber}
          </Typography>
          <Typography variant="h6">
            Order #{orderID.slice(-3)}
          </Typography>
        </Box>
        <CompleteOrderButton isComplete={() => {return complete}}></CompleteOrderButton>
      </Box>

      <Divider></Divider>
      <Typography variant="h6">
          Ready
      </Typography>
      <List sx={{ width: '100%', p: 2}}>
        {
          ready.map((dish) => {
            const dishID = dish[0];
            const dishDetails = dish[1];

            //when it gets checked or unchecked, servs and unserves respectively
            function handleChange(event) {
              if (event.target.checked) {
                serve(dishID);
              }
              else {
                unserve(dishID);
              }
            }

            let status = (dishDetails.status > 2);

            return (
              <TickBoxDish key={dishID} dishInfo={dishDetails} handleChange={handleChange} checked={status}></TickBoxDish>
            )
          })
        }
      </List>
      <Divider></Divider>
      <Typography variant="h6">
          Cooking
      </Typography>
      <List sx={{ width: '100%', p: 1 }}>
        {
          cooking.map((dish) => {
            const dishID = dish[0];
            const dishDetails = dish[1];

            let dishLabel = dishDetails.name;

            if (dishDetails.quantity > 1) {
              dishLabel = dishDetails.quantity + "x " + dishDetails.name;
            }

            return (<Typography key={dishID} variant="h6" sx={{fontSize: '16px', pl: 1}}>
                        • {dishLabel}
                    </Typography>)
          })
        }
      </List>
    </Box>
  )
}